import { scrollbarWidth } from '@xobotyi/scrollbar-width';
import '@/assets/scss/grid-utils.scss';

/**
 * Adds globally grid css utility classes (ws-grid, ...).
 *
 * Notice: it's not actually a grid; it's a set of classes
 * for specifying only width according to grid.
 *
 */
export default {
  install() {
    setTimeout(() => {
      const width = scrollbarWidth() || 0;

      document.body.style.setProperty('--scrollbar-width', `${width}px`);
    }, 100);
  }
};
